/**
 * Monitor Agent 点击参数
 */
export interface MonitorAgentClickParams {
    /**
     * Agent ID（单个 agent 时使用）
     */
    agentId?: string;

    /**
     * Team ID（agent team 时使用）
     */
    teamId?: string;
}

/**
 * Monitor Agent 服务接口
 * 负责处理 monitor agent 的点击事件
 * 1. 根据 agent_id 或 team_id 通过 Agent API 创建会话获取 job_id
 * 2. 路由跳转到 /monitor?job_id=xxx
 */
export interface MonitorAgentService {
    /**
     * 处理 Monitor Agent 点击事件
     * 调用 Agent API 获取 job_id，然后跳转到 monitor 页面
     *
     * @param params - 包含 agentId 或 teamId 的参数对象
     * @returns Promise，成功则 resolve，失败则 reject
     */
    handleClick(params: MonitorAgentClickParams): Promise<void>;
}

export const MonitorAgentService = Symbol.for('MonitorAgentService');
